
import { token, host } from '../../Connnection';

export default async function getListById(principleId) {

    try {
        let res = await fetch(`${host}/api/PrincipleCheckbox/${principleId}`, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
        })
        return await res.json();
    } catch (error) {
        console.log(error);
    }
}